import { combineReducers } from '@reduxjs/toolkit';
import { AppReducer } from './App';
import { DeveloperReducer } from './Developer';
import { AuthorizationReducer } from './Authorization';

export const rootReducer = combineReducers({
	AppReducer,
	DeveloperReducer,
	AuthorizationReducer,
});